var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReviewStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16 3.236-3.982 7.965a1.5 1.5 0 0 1-1.193.821l-7.626.763 5.308 5.308a1.5 1.5 0 0 1 .394 1.424L6.578 28.81l8.617-5.483a1.5 1.5 0 0 1 1.61 0l8.617 5.483-2.323-9.293a1.5 1.5 0 0 1 .394-1.424l5.308-5.308-7.626-.763a1.5 1.5 0 0 1-1.193-.821zm-5.648 6.824 4.306-8.613a1.5 1.5 0 0 1 2.684 0l4.306 8.613 8.402.84a1.5 1.5 0 0 1 .911 2.553l-5.854 5.854 2.56 10.234a1.5 1.5 0 0 1-2.261 1.63L16 25.185l-9.406 5.986a1.5 1.5 0 0 1-2.26-1.63l2.559-10.234-5.854-5.854A1.5 1.5 0 0 1 1.95 10.9z"
})));
export default SvgReviewStar;